import { AppDataDTO } from "./AppDataDTO";
import { ShareDataDTO } from "./ShareDataDTO";
export class ThemeDTO {
    primaryColor: string;
    accentColor: string;
    warnColor: string;
    primaryLogoUrl: string;
    secondaryLogoUrl: string;
    poweredByLogoUrl: string;
    favIconUrl: string;
    fontFamily: string;
    bannerUrl: string;
    bannerLoginUrl: string;
    adminLogoUrl: string;
    shortName: string;
    appData: AppDataDTO;
    shareData: ShareDataDTO;
    headerHtml: string;

    constructor(obj?) {
        obj = obj || {};

        this.primaryColor = obj.primaryColor || null;
        this.accentColor = obj.accentColor || null;
        this.warnColor = obj.warnColor || null;
        this.primaryLogoUrl = obj.primaryLogoUrl || null;
        this.secondaryLogoUrl = obj.secondaryLogoUrl || null;
        this.poweredByLogoUrl = obj.poweredByLogoUrl || null;
        this.favIconUrl = obj.favIconUrl || null;
        this.fontFamily = obj.fontFamily || null;
        this.bannerUrl = obj.bannerUrl || null;
        this.bannerLoginUrl = obj.bannerLoginUrl || null;
        this.adminLogoUrl = obj.adminLogoUrl || null;
        this.shortName = obj.shortName || null;
        this.appData = obj.appData || null;
        this.shareData = obj.shareData || null;
        this.headerHtml = obj.headerHtml || null;
    }
}
